import React from "react";
import { Player } from "video-react";
import "./VideoLink.scss";
import { Button } from "rsuite";
import type { VideoLinksActivityDetails } from "../../../entities/Activity/types";
import { formClass } from "../../../shared/helpers";
import QuizComponent from "../QuizComponent/QuizComponent";

type Props = {
	activity: VideoLinksActivityDetails;
	activityId: string;
};

const VIdeoLinkActivity: React.FC<Props> = ({ activity }) => {
	const prefixClass = "video-link-activity";
	const [showQuiz, setShowQuiz] = React.useState(false);
	return (
		<div className={formClass(prefixClass)}>
			<div>{activity?.url && <Player playsInline src={activity.url} />}</div>
			<div className={formClass(prefixClass, "embedded")}>
				{activity?.embedded && (
					// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
					<div dangerouslySetInnerHTML={{ __html: activity.embedded }} />
				)}
			</div>
			{activity?.quiz && (
				<div>
					{activity?.quiz?.details?.instruction && (
						<h5 className={formClass(prefixClass, "quiz-instruction")}>
							{activity?.quiz?.details?.instruction}
						</h5>
					)}
					{activity?.quiz?.details?.description && (
						<p className={formClass(prefixClass, "quiz-description")}>
							{activity.quiz.details.description}
						</p>
					)}
					<Button
						className={formClass(prefixClass, "show-quiz-btn")}
						onClick={() => setShowQuiz((prev: boolean) => !prev)}
						appearance="primary"
						type="button"
					>
						Show Quiz
					</Button>
					{activity?.quiz?.details?.questions && showQuiz && (
						<QuizComponent
							questions={activity.quiz.details.questions}
							activityId={activity._id}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default VIdeoLinkActivity;
